import { connect } from 'react-redux';
import _get from 'lodash/get';
import { Select } from '@casanova/casanova-common';

const withListOptions = connect((state, { options }) => {
  const data = _get(state, options, {});
  return {
    options: data.list || [],
  };
});

export default withListOptions(Select);
